<template>
  <div class="footer">
    <div class="phone-hidden">
      <div class="search">
        <van-field
          center
          clearable
          v-model="inputSelectVal"
          placeholder="搜索">
          <template #button>
            <div class="icon">
              <span
                @click="goSearchIndex"
                class="iconfont icon-sousuo"></span>
            </div>
          </template>
        </van-field>
      </div>
      <div class="collapse">
        <div
          class="collapse-box"
          style="margin-bottom: 10px">
          <van-collapse
            ref="collapseRef"
            v-model="serviceActive">
            <van-collapse-item>
              <template #title>
                <div class="title">服务支持</div>
              </template>
              <van-collapse-item
                @click.native="goBtnService(s)"
                v-for="s in flooterPlate.service_supports"
                :key="s.id"
                :name="s.id + s.name"
                readonly
                :is-link="false">
                <template #title>
                  <div class="content">{{ s.name }}</div>
                </template>
              </van-collapse-item>
            </van-collapse-item>
            <van-collapse-item>
              <template #title>
                <div class="title">{{ home_contact_us.title }}</div>
              </template>
              <van-collapse-item
                readonly
                :is-link="false">
                <template #title>
                  <div class="content">
                    联系电话：{{ home_contact_us.phone }}
                  </div>
                </template>
              </van-collapse-item>
              <van-collapse-item
                readonly
                :is-link="false">
                <template #title>
                  <div class="content">
                    时间：{{ home_contact_us.createTime }}
                  </div>
                </template>
              </van-collapse-item>
              <van-collapse-item
                readonly
                :is-link="false">
                <template #title>
                  <div class="content">邮箱：{{ home_contact_us.eMail }}</div>
                </template>
              </van-collapse-item>
              <van-collapse-item
                readonly
                :is-link="false">
                <template #title>
                  <div class="content">地址：{{ home_contact_us.address }}</div>
                </template>
              </van-collapse-item>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <div class="btn">
        <div
          class="btn-item"
          @click="
            toPage(
              'https://vargoos-cloud.jingshucloud.com/'
            )
          ">
          登录
        </div>
        <div
          class="btn-item"
          @click="
            toPage(
              'https://vargoos-cloud.jingshucloud.com/'
            )
          ">
          注册
        </div>
        <div
          class="btn-item"
          v-for="d in flooterPlate.distribution_channels"
          :key="d.id">
          {{ d.name }}
        </div>
      </div>
      <div class="desc">
        <div class="desc-logo">
          <img
            src="https://oss.jingshucloud.com/gw-bucket/a1c740b7-956c-4d1a-b9e9-f30c613b7664.png"
            alt="" />
        </div>
        <div class="desc-content">
          <p>©2005-2022 京数科技（上海）有限公司 版权所有</p>
          <p>泸ICP备14033346号-2</p>
        </div>
      </div>
    </div>
    <div class="ipad-hidden">
      <div class="ipadContainer">
        <div class="ipadContainer-topBox">
          <div class="cont">
            <div class="logo">
              <img
                src="https://oss.jingshucloud.com/gw-bucket/a1c740b7-956c-4d1a-b9e9-f30c613b7664.png"
                alt="" />
            </div>
            <div class="cont-list">
              <div class="cont-list__title">Vargo云</div>
              <div
                class="cont-list__item"
                @click="
                  toPage(
                    'https://vargoos-cloud.jingshucloud.com/'
                  )
                ">
                登入
              </div>
              <div
                class="cont-list__item"
                @click="
                  toPage(
                    'https://vargoos-cloud.jingshucloud.com/'
                  )
                ">
                注册
              </div>
            </div>
            <div class="cont-list">
              <div class="cont-list__title">销售渠道</div>
              <div
                class="cont-list__item"
                v-for="d in flooterPlate.distribution_channels"
                :key="d.id">
                {{ d.name }}
              </div>
            </div>
            <div class="cont-list">
              <div class="cont-list__title">服务支持</div>
              <div
                class="cont-list__item"
                @click="goBtnService(s)"
                v-for="s in flooterPlate.service_supports"
                :key="s.id">
                {{ s.name }}
              </div>
            </div>
            <div class="cont-list">
              <div class="cont-list__title">联系我们</div>
              <div class="cont-list__item">
                <span></span>
                {{ home_contact_us.phone }}
              </div>
              <div class="cont-list__item">
                <span></span>
                {{ home_contact_us.createTime }}
              </div>
              <div class="cont-list__item">
                <span></span>
                {{ home_contact_us.eMail }}
              </div>
              <div class="cont-list__item">
                <span></span>
                {{ home_contact_us.address }}
              </div>
            </div>
          </div>
        </div>
        <div class="ipadContainer-filing">
          © 2005-2024 京数科技 (上海) 有限公司 沪 ICP 备 2023025523 号-1
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { homeBottom } from '@/api/index';
export default {
  data() {
    return {
      serviceActive: [],
      flooterPlate: {},
      home_contact_us: {},
      inputSelectVal: '',
    };
  },
  created() {
    this.getHomeBottom();
  },
  methods: {
    toPage(url) {
      location.href = url;
    },
    goSearchIndex() {
      if (!this.inputSelectVal) return this.$toast('请输入关键词');
      this.$router.push({
        name: 'globalSearch',
        params: { info: this.inputSelectVal },
      });
    },
    goBtnService(res) {
      this.$router.push({
        // name: "detailTempIndex/templateDetail",
        name: res.routingPath,
        params: { id: res.id },
        // replace: true,
      });
    },
    getHomeBottom() {
      homeBottom().then((res) => {
        var { data } = res;
        this.flooterPlate = data.data;
        this.home_contact_us = data.data.home_contact_us[0];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
/* phone */
@media (max-width: $phone-max-size) {
  .footer {
    background: #f5f5f6;
    margin-top: auto;
    padding-top: 20px;
    padding-bottom: 12px;
    font-family: PingFang SC, PingFang SC;

    .search {
      width: 345px;
      margin: 0 auto 20px;
      font-size: 15px;

      .icon {
        color: #999999;
        display: inline-flex;
        align-items: center;

        .iconfont {
          padding-left: 12px;
          position: relative;

          &::after {
            content: '';
            width: 1px;
            height: 60%;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            background-color: #e8e8ff;
          }
        }
      }

      .van-cell {
        --van-field-input-text-color: #9c0f0f;
        --van-cell-vertical-padding: 5px;
        --van-cell-horizontal-padding: 20px;
      }
    }

    .collapse {
      width: 345px;
      margin: auto;

      &-box {
        .title {
          font-weight: 600;
          font-size: 14px;
          color: #333333;
          display: flex;
          align-items: center;
          height: 100%;
        }
        .content {
          font-weight: 400;
          font-size: 12px;
          color: #151a23;
          line-height: 14px;
          padding: 0 6px;
        }
        ::v-deep .van-collapse {
          &::after {
            border-color: rgba($color: #d4d4d4, $alpha: 0.8);
          }
          .van-collapse-item {
            &--border::after {
              border-color: rgba($color: #d4d4d4, $alpha: 0.8);
              left: 0;
              right: 0;
            }
            &__content {
              background: none;
              color: #ffffff;
              padding: 0;
            }
            .van-cell {
              background: none;
              font-weight: 500;
              font-size: 15px;
              color: #ffffff;
              padding: 12px 6px;
              &__right-icon {
                color: #666666;
              }
              &::after {
                left: 0;
                right: 0;
                border-color: rgba($color: #e2e2e2, $alpha: 0.4);
              }
            }
          }
        }
      }
    }

    .btn {
      display: flex;
      border-bottom: 1px solid #e8e8ff;
      justify-content: space-around;
      color: #666666;
      font-size: 12px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      padding: 40px 30px 20px;
      margin-bottom: 20px;
    }

    .desc {
      font-size: 9px;
      color: #666666;
      text-align: center;

      &-logo {
        width: 81px;
        margin: auto;

        img {
          width: 100%;
        }
      }
    }
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  $container-width: 700px;
  .footer {
    background: #f5f5f6;
    .ipadContainer {
      &-topBox {
        width: $container-width;
        margin: auto;
        padding: 43px 0;
        .logo {
          img {
            width: 136px;
          }
        }
        .cont {
          display: flex;
          justify-content: space-between;
          &-list {
            &:nth-last-of-type(1) {
              width: 200px;
            }
            &__title {
              font-weight: 700;
              font-size: 12px;
              color: #151a23;
              margin-bottom: 8px;
            }
            &__item {
              font-weight: 400;
              font-size: 11px;
              color: #151a23;
              margin-bottom: 8px;
              &:nth-last-of-type(1) {
                margin-bottom: 0;
              }
            }
          }
        }
      }
      &-filing {
        border-top: 1px solid #e2e2e2;
        padding: 14px;
        font-weight: 400;
        font-size: 10px;
        color: #151a23;
        text-align: center;
      }
    }
  }
}
</style>
